<template>
  <div>
    <p class='mb-5'>{{ 'period.new.description' | translate }}</p>
    <report-of-sickness-card :employee="this.employee" :reportOfSickness="reportOfSickness" class='mt-5 mb-4'/>

    <form-input-container
      title='Uw Invoer voor Wijziging in Verzuim Doorgeven'
      text='De door u ingevoerde gegevens voor wijziging in het verzuim van de werknemer.'>

      <table class='confirmation-table'>
        <tr>
          <td>{{ 'period.form.start-date' | translate }}</td>
          <td>{{ getFormattedDate(period.startDate) }}</td>
        </tr>
        <tr class='confirmation-row'>
          <td>{{ 'report-of-sickness.disability-rate' | translate }}</td>
          <td>{{ period.disabilityRate }}%</td>
        </tr>
      </table>
    </form-input-container>

    <div style='float: right' class='mt-4'>
      <Button primary class="mr-3" @click="this.handlePreviousClick">
        {{ 'buttons.previous-step' | translate }}
      </Button>

      <Button positive @click="this.handleConfirmationClick" :disabled="!isValid || isCreateLoading">
        {{ isCreateLoading ? 'period.form.confirming-and-creating' : 'period.form.confirm-and-create' | translate }}
      </Button>
    </div>
  </div>
</template>

<script>
import NewPeriodConstants from '@/views/constants/period-new';
import ReportsOfSickness from '@/resources/constants/reports-of-sickness';

import Helpers from '@/shared/helpers/functions';
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';

import ReportOfSicknessCard from '@/views/components/reports-of-sickness/ReportOfSicknessCard.vue';

export default {
  name: 'NewPeriodConfirmation',
  components: {
    ReportOfSicknessCard,
    FormInputContainer,
    Button
  },
  props: {
    reportOfSickness: Object,
    employee: Object
  },
  computed: {
    period () {
      return this.$store.getters.newPeriod;
    },
    isValid () {
      return this.$store.getters.newPeriodValidations.isValid() &&
        this.$store.getters.newPeriodRequiredFields.isValid();
    },
    isCreateLoading () {
      return this.$store.getters.isCreatePeriodLoading;
    }
  },
  methods: {
    handlePreviousClick () {
      this.$store.dispatch(NewPeriodConstants.Actions.Navigate.DO,
        NewPeriodConstants.Views.NewPeriodInputForm);
    },
    handleConfirmationClick () {
      this.$store.dispatch(ReportsOfSickness.Actions.Period.Create.START,
        { reportOfSickness: this.reportOfSickness, period: this.period });
    },
    getFormattedDate (value) {
      return Helpers.Dates.formatDate(value);
    }
  }
};
</script>
